import React, { useEffect } from 'react';
import Routes from './routes';
import './assets/styles/global.css';
import './assets/styles/generic.css';
import { SnackbarProvider } from 'notistack';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { persistor, RootState, Store } from './store';
import { UserState } from './store/reducers/userReducer';
import { MenuState } from './store/reducers/menuReducer';
import { Grid } from '@material-ui/core';
import { CircularProgress } from '@mui/material';
import { PersistGate } from 'redux-persist/integration/react';
import { useCookies } from 'react-cookie';
import AccountService from "./services/AccountService/AccountService";
import SolicitationService from "./services/SolicitationService/SolicitationService";
import { PivotProvider } from './contexts/PivotContext';

const App: React.FC = () => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const [cookies, setCookie, removeCookie] = useCookies(['root']);
    const accountService = new AccountService({});
    const solicitationService = new SolicitationService({});
    const dispatch = useDispatch();

    //useEffect(() => {
    //    window.addEventListener("beforeunload", (e) => {
    //        e.preventDefault();
    //        removeCookie('root');
    //    });
    //}, [])

    useEffect(() => {
        getDataBaseType();
    }, [])

    const getDataBaseType = async () => {
        try {
            const response = await accountService.GetDataBaseType();
            dispatch({ type: 'MENU_PROD_QA_DATABASE', payload: response && response.data === "prd" });
        }
        catch (error) {
            debugger;
        }
    }

    useEffect(() => {
        if (user.id) {
            const getPrefs = async () => {
                try {
                    const prefs = await solicitationService.GetPref(user.id);

                    if (prefs.data.length > 0) {
                        dispatch({
                            type: 'PREF_LOAD',
                            payload: JSON.parse(prefs.data[0].json)
                        });
                    }
                }
                catch (error) {
                    debugger
                }
            }

            getPrefs();
        }
    }, [user])


    if (user && user.nickName) {

        return (
            <PivotProvider>
                <Provider store={Store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <SnackbarProvider
                            preventDuplicate
                            hideIconVariant
                            dense
                            maxSnack={4}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}>
                            <Routes />
                        </SnackbarProvider>
                    </PersistGate>
                </Provider>
            </PivotProvider>
        );
    } else {
        return (

            <Grid container justifyContent="center" alignItems="center">
                <CircularProgress />
            </Grid>
        );
    }
}

export default App;